module.exports = __webpack_public_path__ + "img/airbase-detail.8afed4dd.jpg";